import Vue from 'vue';
import i18n from '../i18n/i18n-config';

const eventBus = new Vue();

// event types
export const OPEN_CONFIRM_DIALOG = 'open-confirm-dialog';
export const CONFIRM_DIALOG_CLOSED = 'confirm-dialog-closed';
export const OPEN_SNACKBAR = 'open-snackbar';
export const OPEN_TWO_FACTOR_REMINDER = 'open-two-factor-reminder';

// helper to open confirm dialog with less code
export const openConfirmDialog = (params) => {
  eventBus.$emit(OPEN_CONFIRM_DIALOG, {
    title: params?.title || i18n.t('confirm_entry_delete'),
    confirmText: params?.confirmText || i18n.t('confirm'),
    cancelText: params?.cancelText || i18n.t('cancel'),
    maxWidth: params?.maxWidth || 400,
  });
  return new Promise((resolve) => {
    eventBus.$on(CONFIRM_DIALOG_CLOSED, async (confirmed) => {
      resolve(confirmed);
      eventBus.$off(CONFIRM_DIALOG_CLOSED);
    });
  });
};

export default eventBus;
